/* eslint-disable consistent-return */
/* eslint-disable no-else-return */
import axios from 'axios';
import moment from 'moment';
import * as TYPES from './ManufacturerActionType';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
// get All manufacturer List data
export const dispatchAllManufacturer = (data) => {
  return { type: TYPES.GET_ALL_MANUFACTURERS, manufacturerList: data };
};
// get All manufacturer gov
export const dispatchAllManufacturerGov = (data) => {
  return {
    type: TYPES.GET_ALL_MANUFACTURER_SEARCH_BY_G,
    manufacturerFilterByGovList: data,
  };
};
export const dispatchAllManufacturerCom = (data) => {
  return {
    type: TYPES.GET_ALL_MANUFACTURER_SEARCH_BY_C,
    manufacturerFilterByComList: data,
  };
};
export const dispatchAllMFGLabelers = (data) => {
  return {
    type: TYPES.GET_ALL_MFG_LABELERS,
    MFGLabelerList: data,
  };
};
export const dispatchLabelerUsingManufacturer = (data) => {
  return {
    type: TYPES.GET_LABELER_USING_MANUFACTURES,
    labelerUsingMFG: data,
  };
};
export const dispatchAllMFGContract = (data) => {
  return {
    type: TYPES.GET_ALL_MFG_CONTRACTS,
    contractList: data,
  };
};
export const dispatchSearchLabelerData = (data) => {
  return {
    type: TYPES.SEARCH_LABELER_POPUP_DATA_ACTION_TYPES,
    searchLabelerList: data,
  };
};

export const dispatchAllManufacturerDetails = (data) => {
  return {
    type: TYPES.GET_ALL_MANUFACTURER_DETAILS_ACTION_TYPE,
    manufacturerDetailsList: data,
  };
};
export const dispatchContractUsingContact = (data) => {
  return {
    type: TYPES.CONTRACT_USING_CONTACT_TYPE,
    contractUsingContactData: data,
  };
};

export const setSearchManufacturerTab = (data) => {
  return {
    type: TYPES.SEARCH_MANUFACTURER_TAB_DATA,
    searchManufacturerObj: data,
  };
};
export const setMaintainManufacturerTab = (data) => {
  return {
    type: TYPES.MAINTAIN_MANUFACTURER_TAB_DATA,
    maintainManufacturerObj: data,
  };
};
export const setSelectManufacturerData = (data) => {
  return {
    type: TYPES.SELECT_DATA_MANUFACTURER,
    selectManufacturerData: data,
  };
};

export const setNewLabelersListAction = (payload) => {
  return {
    type: TYPES.MAINTAIN_LABELER_DATA_ACTION_TYPES,
    payload,
  };
};

export const setNewBankruptcyListAction = (payload) => {
  return {
    type: TYPES.MAINTAIN_BANKRUPTCY_DATA_ACTION_TYPES,
    payload,
  };
};
export const setMaintainBankruptcyDataWithFilter = (payload) => {
  return {
    type: TYPES.MAINTAIN_BANKRUPTCY_FILTER_DATA,
    payload,
  };
};
export const maintainLabelerListData = (payload, action) => {
  // eslint-disable-next-line consistent-return
  return (dispatch, getState) => {
    let currentLabelers = [
      ...getState().sharedState.ManufacturerReducer.labelersList,
    ];
    if (action === 'filter') {
      return dispatch(setNewLabelersListAction(payload));
    }
    if (currentLabelers && currentLabelers.length === 1 && action === 'G') {
      currentLabelers = [];
      currentLabelers.unshift(payload);
      dispatch(setNewLabelersListAction(currentLabelers));
    } else if (Array.isArray(payload) && action === 'verify') {
      currentLabelers = payload;
      dispatch(setNewLabelersListAction(currentLabelers));
    } else if (Array.isArray(payload) && payload && payload.length > 0) {
      let temp = [];
      if (
        !payload.filter((x) => {
          return x.permanentDelete;
        }).length > 0
      ) {
        if (action === 'update') {
          temp = [];
        } else {
          temp = [...currentLabelers];
        }
        dispatch(setNewLabelersListAction(temp.concat(payload)));
      } else {
        dispatch(setNewLabelersListAction(payload));
      }
    } else if (Object.keys(payload) && Object.keys(payload).length === 0) {
      dispatch(setNewLabelersListAction([]));
    } else {
      currentLabelers.unshift(payload);
      dispatch(setNewLabelersListAction(currentLabelers));
    }
  };
};

export const addNewRowBankruptcy = (payload, action) => {
  // eslint-disable-next-line consistent-return
  return (dispatch, getState) => {
    const currentBankruptcyData = [
      ...getState().sharedState.ManufacturerReducer.bankruptcyList,
    ];
    if (action === 'filter') {
      return dispatch(setNewBankruptcyListAction(payload));
    }
    if (Array.isArray(payload) && action === 'verify') {
      const arrayData = payload;
      dispatch(setNewBankruptcyListAction(arrayData));
    } else if (
      Array.isArray(payload) &&
      payload &&
      payload.length > 0 &&
      payload.filter((x) => {
        return x.permanentDelete;
      }).length > 0
    ) {
      let temp = [];
      if (action === 'update') {
        dispatch(setNewBankruptcyListAction(payload));
      } else {
        temp = [...currentBankruptcyData];
        dispatch(setNewBankruptcyListAction(temp.concat(payload)));
      }

      dispatch(setNewBankruptcyListAction(temp.concat(payload)));
    } else if (Object.keys(payload) && Object.keys(payload).length === 0) {
      dispatch(setNewBankruptcyListAction([]));
    } else {
      currentBankruptcyData.unshift(payload);
      dispatch(setNewBankruptcyListAction(currentBankruptcyData));
    }
  };
};

export const deleteLabelersData = (index, rowData) => {
  return (dispatch, getState) => {
    const Obj = [...getState().sharedState.ManufacturerReducer.labelersList];
    if (Obj.length > 0) {
      const key = Obj.findIndex((item) => {
        return (
          item.lalabelerCode === rowData.lalabelerCode &&
          item.labelerName === rowData.labelerName &&
          moment(item.startDate).format('MM/DD/yyyy') ===
            moment(rowData.startDate).format('MM/DD/yyyy')
        );
      });
      Obj.splice(key, 1);
      dispatch(setNewLabelersListAction(Obj));
    }
  };
};

export const permanentDeleteLabelerRow = (values) => () => {
  return axios
    .post(`${serviceEndPoint.DELETE_SINGLE_LABELER}`, values)
    .then(() => {
      return true;
    })
    .catch(() => {});
};
export const deleteBankruptcyData = (index) => {
  return (dispatch, getState) => {
    const data = [...getState().sharedState.ManufacturerReducer.bankruptcyList];
    if (data.length > 0) {
      data.splice(index, 1);
      dispatch(setNewBankruptcyListAction(data));
    }
  };
};
export const permanentDeleteBankruptcyRow = (values) => () => {
  return axios
    .post(`${serviceEndPoint.DELETE_SINGLE_BANKRUPTCY}`, values)
    .then(() => {
      return true;
    })
    .catch(() => {});
};
export const setMaintainGroupContactAction = (payload) => {
  return {
    type: TYPES.MAINTAIN_GROUP_CONTACT_ACTION_TYPES,
    payload,
  };
};
export const getAllManufacturer = (values, mfgTypeCd, action) => (dispatch) => {
  if (values === null) {
    return (
      dispatch(dispatchAllManufacturer([])),
      dispatch(dispatchAllManufacturerGov([])),
      dispatch(dispatchAllManufacturerCom([]))
    );
  }
  if (values === 'copyContact') {
    return dispatch(dispatchAllManufacturer([]));
  }
  if (action === 'filter') {
    if (mfgTypeCd === 'G') return dispatch(dispatchAllManufacturerGov(values));
    if (mfgTypeCd === 'C') return dispatch(dispatchAllManufacturerCom(values));
    return dispatch(dispatchAllManufacturer(values));
  } else {
    return axios
      .post(`${serviceEndPoint.GET_ALL_MANUFACTURERS}`, values)
      .then((response) => {
        if (values.mfgTypeCd === 'G') {
          return dispatch(
            dispatchAllManufacturerGov(response.data && response.data.data)
          );
        }
        if (values.mfgTypeCd === 'C') {
          return dispatch(
            dispatchAllManufacturerCom(response.data && response.data.data)
          );
        }
        return dispatch(dispatchAllManufacturer(response.data));
      })
      .catch(() => {
        dispatch(dispatchAllManufacturer([]));
        dispatch(dispatchAllManufacturerGov([]));
        dispatch(dispatchAllManufacturerCom([]));
      });
  }
};

export const getAllMFGLabelerList = (values, action) => (dispatch) => {
  if (values === null) {
    return dispatch(dispatchAllMFGLabelers([]));
  }
  if (action === 'filter') {
    return dispatch(dispatchAllMFGLabelers(values));
  } else {
    return axios
      .post(`${serviceEndPoint.GET_ALL_MFG_LABELERS}`, values)
      .then((response) => {
        let tempObj = [];
        tempObj =
          response.data &&
          response.data.data.length > 0 &&
          response.data.data.map((prop) => {
            prop.mfgTypeCd = 'C';
            prop.searchType = 'Labeler';
            return prop;
          });
        if (tempObj && tempObj.length > 0) {
          return dispatch(dispatchAllMFGLabelers(tempObj));
        }
        return dispatch(dispatchAllMFGLabelers([]));
      })
      .catch(() => {
        dispatch(dispatchAllMFGLabelers([]));
      });
  }
};
export const getSingleLabelerUsingMFG = (values) => (dispatch) => {
  if (values === null) {
    return dispatch(dispatchLabelerUsingManufacturer({}));
  } else {
    return axios
      .post(`${serviceEndPoint.GET_MANUFACURER_ID}`, values)
      .then((response) => {
        return dispatch(dispatchLabelerUsingManufacturer(response.data.data));
      })
      .catch(() => {
        dispatch(dispatchLabelerUsingManufacturer({}));
      });
  }
};

export const getAllMFGContractList = (values) => (dispatch) => {
  if (values === null) {
    return dispatch(dispatchAllMFGContract([]));
  } else {
    return axios
      .post(`${serviceEndPoint.GET_ALL_MFG_CONTRACTS}`, values)
      .then((response) => {
        if (response.data && response.data.data.length > 0) {
          return dispatch(
            dispatchAllMFGContract(response.data && response.data.data)
          );
        }
        return dispatch(dispatchAllMFGContract([]));
      })
      .catch(() => {
        dispatch(dispatchAllMFGContract([]));
      });
  }
};
export const getSingleContractUsingContact = (values) => (dispatch) => {
  if (values === null) {
    return dispatch(dispatchContractUsingContact([]));
  } else {
    return axios
      .post(`${serviceEndPoint.CONTRACT_USING_CONTACT}`, values)
      .then((response) => {
        if (response.data && response.data.data) {
          let tempObj = [];
          tempObj =
            response.data.data?.length > 0 &&
            response.data.data?.map((item) => {
              item.endDt =
                item.endDt !== null
                  ? moment(item.endDt).format('MM/DD/yyyy')
                  : null;
              item.startDt =
                item.startDt !== null
                  ? moment(item.startDt).format('MM/DD/yyyy')
                  : null;
              return item;
            });
          return dispatch(dispatchContractUsingContact(tempObj));
          // eslint-disable-next-line no-else-return
        } else {
          dispatch(dispatchContractUsingContact([]));
        }
      })
      .catch(() => {
        dispatch(dispatchContractUsingContact([]));
      });
  }
};
export const fetchAllManufacturerDetail = (values) => (dispatch) => {
  if (values === null) {
    dispatch(dispatchAllManufacturerDetails([]));
  } else {
    return axios
      .post(`${serviceEndPoint.GET_ALL_MANUFACTURERS_DETAIL}`, values)
      .then((response) => {
        return dispatch(
          dispatchAllManufacturerDetails(response.data && response.data.data)
        );
      })
      .catch(() => {
        dispatch(dispatchAllManufacturerDetails([]));
      });
  }
};
export const getSearchLabelers = (values) => (dispatch) => {
  if (values === null) {
    return dispatch(dispatchSearchLabelerData([]));
  } else {
    return axios
      .post(`${serviceEndPoint.GET_SEARCH_LABELERS}`, values)
      .then((res) => {
        let tempObj = [];
        tempObj =
          res.data &&
          res.data.data.length > 0 &&
          res.data.data.map((prop) => {
            prop.value = false;
            return prop;
          });
        return dispatch(dispatchSearchLabelerData(tempObj));
      })
      .catch(() => {
        dispatch(dispatchSearchLabelerData([]));
      });
  }
};

export const dispatchSaveOrUpdate = (values) => {
  return {
    saveOrUpdateMessage: values,
    type: TYPES.SAVE_OR_UPDATE,
  };
};
export const resetUpdateOrSaveMessage = (message) => (dispatch) => {
  if (message === '') return dispatch(dispatchSaveOrUpdate(message));
  return dispatch(dispatchSaveOrUpdate(''));
};
export const postSaveOrUpdate = (value) => (dispatch) => {
  if (value === null) {
    dispatch(dispatchSaveOrUpdate(null));
  } else {
    return axios
      .post(serviceEndPoint.ADDUPDATE_MANUFACTURER_DETAIL, value)
      .then((res) => {
        const resObj = res.data && res.data.data;
        const tempObj = {};
        tempObj.message = 'SUCCESS';
        tempObj.mfgId = resObj && resObj.mfgVO.mfgId;
        tempObj.mfgTypeCd = resObj && resObj.mfgVO.mfgTypeCd;
        return dispatch(dispatchSaveOrUpdate(tempObj));
      })
      .catch(() => {
        dispatch(dispatchSaveOrUpdate('failed'));
      });
  }
};

export const updateContactDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_CONTACT_DETAILS, values)
    .then((response) => {
      dispatch(dispatchUpdateContactDetail(response.data));
    })
    .catch(() => {
      dispatch(dispatchUpdateContactDetail({ error: 'API failed' }));
    });
};
export const getContactDetails = (values) => (dispatch) => {
  if (values === null) {
    return dispatch(dispatchContactDetails([]));
  } else {
    return axios
      .post(serviceEndPoint.GET_CONTACT_DETAILS, values)
      .then((res) => {
        return dispatch(dispatchContactDetails(res.data));
      })
      .catch(() => {
        return dispatch(dispatchContactDetails([]));
      });
  }
};

export const getExistingContactDetails = (values) => (dispatch) => {
  if (values === null || values.key === null) {
    return dispatch(dispatchExistingContactDetails([]));
  } else {
    return axios
      .post(serviceEndPoint.GET_EXISTING_CONTACT_DETAILS, values)
      .then((response) => {
        dispatch(dispatchExistingContactDetails(response.data));
      })
      .catch(() => {
        dispatch(dispatchExistingContactDetails({ error: 'API failed' }));
      });
  }
};
export const getAllContactType = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CONTACT_DESCRIPTION_DETAILS, value)
    .then((response) => {
      return dispatch(dispatchContactType(response.data));
    })
    .catch(() => {
      dispatch(dispatchContactType([]));
    });
};

export const resetUpdateContactDetail = (message) => (dispatch) => {
  return dispatch(dispatchUpdateContactDetail(message));
};

export const dispatchUpdateContactDetail = (message) => {
  return {
    type: TYPES.UPDATE_CONTACT_DETAILS,
    updateOrSaveContactDetailsMessage: message,
  };
};

export const dispatchContactType = (values) => {
  return {
    allContactTypeDropDown: values,
    type: TYPES.GET_CONTACT_TYPE,
  };
};

export const dispatchExistingContactDetails = (data) => ({
  type: TYPES.GET_EXISTING_CONTACT_DETAILS_MFG,
  existingContactDetails: data,
});
export const dispatchContactDetails = (data) => ({
  type: TYPES.GET_CONTACT_DETAILS,
  contactDetails: data,
});
export const dispatchGetGeneralSystemParametersResultDetails = (data) => ({
  type: TYPES.GET_GENERAL_SYSTEM_PARAMETER,
  generalSystemParameter: data,
});
export const getGeneralSystemParameterDetails = (values) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_GENERAL_SYSTEM_PARAMETER, values)
    .then((response) => {
      dispatch(
        dispatchGetGeneralSystemParametersResultDetails(
          response.data && response.data.data
        )
      );
    })
    .catch(() => {
      dispatch(dispatchGetGeneralSystemParametersResultDetails([]));
    });
};

export const dispatchCopyContactDropdown = (values) => {
  return {
    getAllDropdownValues: values,
    type: TYPES.COPY_CONTACT_GET_CLIENT_CODE_VALUES,
  };
};
export const getCopyContactDropdownList = (values) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_CLIENT_CODE_VALUES, values)
    .then((res) => {
      let newObj = [];
      if (res && res.data && res.data.length > 0) {
        newObj = res.data.map((x) => {
          return {
            text: `${x.codeValueID.codeValue} | ${x.longDescription}`,
            value: x.codeValueID.codeValue,
          };
        });
        dispatch(dispatchCopyContactDropdown(newObj));
      } else {
        dispatch(dispatchCopyContactDropdown([]));
      }
    })
    .catch(() => {
      dispatch(dispatchCopyContactDropdown([]));
    });
};

export const dispatchGetAllClientList = (values) => {
  return {
    allClientGroupList: values,
    type: TYPES.GET_ALL_CLIENT_GROUP_FOR_COPY_CONTACT,
  };
};
export const getAllClientGroupList = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_CLIENT_GROUP_FOR_COPY_CONTACT, values)
    .then((res) => {
      let newObj = [];
      if (res && res.data && res.data.data && res.data.data.length > 0) {
        newObj = res.data.data.map((x) => {
          x.groupId =
            x.groupId !== null && x.groupId !== undefined
              ? x.groupId
              : x.clientGroupId.groupId;
          return x;
        });
        dispatch(dispatchGetAllClientList(newObj));
      } else {
        dispatch(dispatchGetAllClientList([]));
      }
    })
    .catch(() => {
      dispatch(dispatchGetAllClientList([]));
    });
};

export const dispatchGetAllClientGroupPlanList = (values) => {
  return {
    allClientGroupPlanList: values,
    type: TYPES.GET_ALL_CLIENT_GROUP_PLAN_FOR_COPY_CONTACT,
  };
};
export const getAllClientGroupByPlanList = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_CLIENT_GROUP_PLAN_FOR_COPY_CONTACT, values)
    .then((res) => {
      dispatch(dispatchGetAllClientGroupPlanList(res.data?.data));
    })
    .catch(() => {
      dispatch(dispatchGetAllClientGroupPlanList([]));
    });
};

export const dispatchGetAllClientListData = (values) => {
  return {
    allClientListData: values,
    type: TYPES.GET_ALL_CLIENT_FOR_COPY_CONTACT,
  };
};
export const getAllClientListData = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_CLIENT_FOR_COPY_CONTACT, values)
    .then((res) => {
      dispatch(dispatchGetAllClientListData(res.data?.data));
    })
    .catch(() => {
      dispatch(dispatchGetAllClientListData([]));
    });
};

export const dispatchGetAllContractList = (values) => {
  return {
    allContractListData: values,
    type: TYPES.GET_ALL_CONTRACT_FOR_COPY_CONTACT,
  };
};
export const getGetAllContractList = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_CONTRACT_FOR_COPY_CONTACT, values)
    .then((res) => {
      dispatch(dispatchGetAllContractList(res.data?.data));
    })
    .catch(() => {
      dispatch(dispatchGetAllContractList([]));
    });
};

export const dispatchGetAllProviderList = (values) => {
  return {
    allProviderListData: values,
    type: TYPES.GET_ALL_PROVIDER_FOR_COPY_CONTACT,
  };
};

export const addProviderApiCancelSource = (cancelSource) => {
  return {
    cancelSource: cancelSource,
    type: TYPES.ADD_PROVIDER_API_CANCEL_SOURCE,
  };
};

export const clearProviderApiCancelSources = () => {
  return {
    type: TYPES.CLEAR_PROVIDER_API_CANCEL_SOURCES,
  };
};

export const getGetAllProviderList = (values) => (dispatch) => {
  const cancelSource = axios.CancelToken.source();
  
  dispatch(addProviderApiCancelSource(cancelSource));
  
  return axios
    .post(serviceEndPoint.GET_ALL_PROVIDER_FOR_COPY_CONTACT, values, {
      cancelToken: cancelSource.token,
    })
    .then((res) => {
      dispatch(dispatchGetAllProviderList(res.data?.data));
    })
    .catch(() => {
      dispatch(dispatchGetAllProviderList([]));
    });
};

export const cancelProviderApiRequest = () => (dispatch, getState) => {
  try {
    const state = getState();
    const cancelSources = state.sharedState.ManufacturerReducer.providerApiCancelSources;
    
    if (cancelSources && cancelSources.length > 0) {
      cancelSources.forEach((cancelSource) => {
        if (cancelSource) {
          cancelSource.cancel('Request cancelled due to component unmount');
        }
      });
    }
  } catch (error) {
  }
  
  dispatch(clearProviderApiCancelSources());
};
export const dispatchGetAllExistingContactList = (values) => {
  return {
    getAllExistingContactList: values,
    type: TYPES.GET_EXISTING_CONTACT_DETAILS_FOR_COPY_CONTACT,
  };
};
export const getExistingContactList = (values) => (dispatch) => {
  if (values === null) {
    return dispatch(dispatchGetAllExistingContactList([]));
  }
  return (
    axios
      .post(serviceEndPoint.GET_EXISTING_CONTACT_FOR_MFG, values)
      // eslint-disable-next-line consistent-return
      .then((res) => {
        if (res.data && res.data.data.length > 0) {
          return dispatch(
            dispatchGetAllExistingContactList(res.data && res.data.data)
          );
          // eslint-disable-next-line no-else-return
        } else dispatch(dispatchGetAllExistingContactList([]));
      })
      .catch(() => {
        return dispatch(dispatchGetAllExistingContactList([]));
      })
  );
};
export const getExistingManufactureId = (values) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_MANUFACTURER_ID, values)
    .then((response) => {
      return response.data?.data;
    })
    .catch(() => {
      return {
        existMfg: false,
      };
    });
};
export const clearReduxManufacturerFirstScreen = () => (dispatch) => {
  dispatch(setSearchManufacturerTab({}));
  dispatch(dispatchAllManufacturerGov([]));
  dispatch(dispatchAllManufacturerCom([]));
};
export const clearReduxManufacturerSecondScreen = () => (dispatch) => {
  dispatch(cancelProviderApiRequest());
  dispatch(setMaintainManufacturerTab({}));
  dispatch(dispatchAllMFGLabelers([]));
  dispatch(dispatchGetAllExistingContactList([]));
  dispatch(dispatchLabelerUsingManufacturer({}));
  dispatch(dispatchAllMFGContract([]));
  dispatch(dispatchSearchLabelerData([]));
  dispatch(dispatchAllManufacturerDetails([]));
  dispatch(dispatchContractUsingContact([]));
  dispatch(setSelectManufacturerData({}));
  dispatch(setNewLabelersListAction([]));
  dispatch(setNewBankruptcyListAction([]));
  dispatch(setMaintainBankruptcyDataWithFilter([]));
  dispatch(maintainLabelerListData([]));
  dispatch(setMaintainGroupContactAction([]));
  dispatch(dispatchSaveOrUpdate(''));
  dispatch(dispatchContactType([]));
  dispatch(dispatchUpdateContactDetail([]));
  dispatch(dispatchExistingContactDetails([]));
  dispatch(dispatchContactDetails([]));
  dispatch(dispatchGetGeneralSystemParametersResultDetails({}));
  dispatch(dispatchCopyContactDropdown([]));
  dispatch(dispatchGetAllClientList([]));
  dispatch(dispatchGetAllClientGroupPlanList([]));
  dispatch(dispatchGetAllClientListData([]));
  dispatch(dispatchGetAllContractList([]));
  dispatch(dispatchGetAllExistingContactList([]));
  dispatch(dispatchGetAllProviderList([]));
};
